import { rankWith, isNumberControl } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { NumberInput } from '../../../../../controls/NumberInput';
import { FormItem } from '../../../../../controls/FormItem';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import './style.scss';

const NumberControl = ({
  path,
  label,
  data,
  required,
  schema,
  uischema,
  disabled,
  handleChange,
  handleBlur,
  handleRemove,
  optionalMessage,
}: FieldProps) => {
  const moreInfo = uischema.options?.moreInfo;

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-number-input-control"
      moreInfo={moreInfo}
      optionalMessage={optionalMessage}
    >
      <NumberInput
        value={data?.toString() || ''}
        onBlur={() => handleBlur(path)}
        onChange={(value) => {
          if (!!value) {
            handleChange(path, +value)
          } else {
            handleRemove(path);
          }
        }}
        disabled={disabled}
      />
      {schema.description && (
        <p className="description margin-bottom">{schema.description}</p>
      )}
    </FormItem>
  );
};

export const NumberInputControlEntry = {
  tester: rankWith(3, isNumberControl),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(NumberControl)),
};
